import VueCookie from 'vue-cookie'
import store from '@/store'
import {networkService as network} from '@/services'

export const authService = {

  registerUser({locale = "en", firstName, lastName, phone, email, password, gender = 1, avatarType, isDisplayName, companyName, jobTitle}) {
    return new Promise((resolve, reject) => {
      const request = {locale, firstName, lastName, phone, email, password, gender, avatarType, isDisplayName, companyName, jobTitle}
      console.log(request)
      network
        .post(`/auth/register`, request)
        .then((data) => {
          resolve(data.data)
        })
        .catch((err) => {
          reject(err)
        })
    })
  },

  passwordReset(email) {
    return new Promise((resolve, reject) => {
      const request = {email}
      network
        .post(`/auth/sendPasswordReset`, request)
        .then((data) => {
          resolve(data.data)
        })
        .catch((err) => {
          reject(err)
        })
    })
  },

  resetPassword(email, password, token) {
    return new Promise((resolve, reject) => {
      const request = {email, password, token}
      network
        .post(`/auth/resetPassword`, request)
        .then((data) => {
          resolve(data.data)
        })
        .catch((err) => {
          reject(err)
        })
    })
  },

  login(email, password, locale = 'en') {
    return new Promise((resolve, reject) => {
      const request = {email: email, password: password, locale: locale}
      network
        .post(`/auth/login`, request)
        .then((response) => {
          const {data} = response
          store.commit('authentication/set', {
            authenticated: true,
            token: data.token,
          })
          VueCookie.set('authenticated', 'true', 1)
          resolve(response.data)
          console.log('response.data', response.data)
          // network.get('/users').then((userResponse) => {
          //   const userData = userResponse.data
          //   localStorage.setItem('user', JSON.stringify(data))
          //   store.commit('user/set', userData)
          //   // store.commit('user/set', data.user)
          //   resolve(response.data)
          // })
        })
        .catch((err) => {
          reject(err)
        })
    })
  },

  logout() {
    return new Promise((resolve, reject) => {
      store.commit('authentication/set', false)
      VueCookie.delete('authenticated')
      localStorage.removeItem('user')
      store.commit('resetState')

      resolve(true)
    }).catch((err) => {
      console.log(err)
    })
  },
}
